import { render } from "./HeaderTabs.vue?vue&type=template&id=aa46f39e&scoped=true"
import script from "./HeaderTabs.vue?vue&type=script&lang=js"
export * from "./HeaderTabs.vue?vue&type=script&lang=js"

import "./HeaderTabs.vue?vue&type=style&index=0&id=aa46f39e&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa46f39e"]])

export default __exports__